'use es6';

import * as Operators from 'customer-data-filters/filterQueryFormat/operator/Operators';
import { IS_BETWEEN, IS_NOT_BETWEEN } from 'customer-data-filters/converters/objectSeg/ObjectSegOperatorTypes';
import { fromObjectSegFilterStrict } from 'customer-data-filters/converters/objectSeg/fromObjectSegFilter';
import { SNOWFLAKE_FILTER_FAMILY, isTimePointFilterFormat } from './xo-filter-utils';
import { getIsUngated } from '../../../shared/lib/utils';
import { getIsUngatedToSnowflakePropertyFilterMigration } from '../../utils/filter-utils';
export const validateFilterDateRangeValue = filter => {
  if (!filter) {
    return false;
  }
  return [IS_BETWEEN, IS_NOT_BETWEEN].includes(filter.getIn(['filter', 'operation', 'operator'])) ? filter.getIn(['filter', 'operation', 'lowerBoundTimestamp']) <= filter.getIn(['filter', 'operation', 'upperBoundTimestamp']) : true;
};
export const validateFilterBetweenValue = filter => {
  if (!filter) {
    return false;
  }
  if (filter.getIn(['filter', 'operation', 'propertyType']).includes('date')) {
    return true;
  }
  return [IS_BETWEEN, IS_NOT_BETWEEN].includes(filter.getIn(['filter', 'operation', 'operator'])) ? filter.getIn(['filter', 'operation', 'lowerBound']) <= filter.getIn(['filter', 'operation', 'upperBound']) : true;
};
const isRelativeTimeOperation = filter => {
  var _operation$get;
  const operation = filter.getIn(['filter', 'operation']);
  return (operation === null || operation === void 0 || (_operation$get = operation.get('renderSpec')) === null || _operation$get === void 0 ? void 0 : _operation$get.indexOf('relativeTimeCalculationType')) > -1;
};
export const validateFilterOperatorValue = (filter, userGates) => {
  if (!filter) {
    return false;
  }

  //the new filter components have their own validation logic, so we can just trust that
  //until we do the full clean-up, I'm only applying this to RTP filters but this fn will soon be cleaned up for all filters
  if (getIsUngatedToSnowflakePropertyFilterMigration(userGates) && isRelativeTimeOperation(filter)) {
    return true;
  }
  const operator = fromObjectSegFilterStrict(filter.filter.toJS(), () => filter.field, SNOWFLAKE_FILTER_FAMILY, gate => getIsUngated(gate, userGates), !isTimePointFilterFormat(filter));
  const Operator = Operators[operator.name];
  const operatorIsValid = Operator.isValid(operator);
  return operatorIsValid;
};